import MyLoadable from './MyLoadable';
export default MyLoadable;



// WEBPACK FOOTER //
// ./src/hoc/MyLoadable/index.js